import * as React from 'react'

import { Media } from '~/components'

import ContentDesktop, { ContentDesktopProps } from './content-desktop'
import { ContentMobile, ContentMobileProps } from './content-mobile'

export type ContentProps = ContentMobileProps | ContentDesktopProps

export function Content(props: ContentProps) {
  return <Media mobile={() => <ContentMobile {...props} />} desktop={() => <ContentDesktop {...props} />} />
}
